import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import toLower from 'lodash/toLower';
import isEqual from 'lodash/isEqual';
import classnames from 'classnames';

import Quiz from './children/quiz';
import Poll from './children/poll';
import PollVisualization from './children/pollvisualization';
import QuizVisualization from './children/quizvisualization';
import ShoutboxVisualization from './children/shoutboxvisualization';
import UgcVisualization from './children/ugcvisualization';
import styles from './Interaction.scss';
import Section from '../components/Section';

import { toQueryString } from '../../util';

const presenterItems = [
	{
		title: 'Quiz',
		path: 'quiz',
		excludedTargets: [],
	},
];

const visualizationItems = [
	{
		title: 'Quiz',
		path: 'quizvisualization',
		feature: 'FEATURE_STUDIO_VISUALISATION',
	},
	{
		title: 'Poll',
		path: 'pollvisualization',
		feature: 'FEATURE_STUDIO_VISUALISATION',
		excludedTargets: ['zapplive'],
	},
	{
		title: 'Shoutbox',
		path: 'shoutboxvisualization',
		feature: 'FEATURE_STUDIO_VISUALISATION',
		excludedTargets: ['zapplive'],
	},
	{
		title: 'Challenges',
		path: 'challengevisualization',
		feature: 'FEATURE_STUDIO_VISUALISATION',
		excludedTargets: ['zapplive'],
	},
];

class Interaction extends Component {
	componentWillMount() {
		const {
			match, setChannel, clearAndGetChannel, clearAndGetStream,
		} = this.props;
		const channelId = get(match, 'params.channelId');
		const streamId = get(match, 'params.streamId');
		// and item of the type
		if (channelId && streamId) {
			clearAndGetChannel(channelId);
			setChannel(channelId);
			clearAndGetStream(streamId);
		}
	}

	shouldComponentUpdate(nextProps) {
		const { match, title } = this.props;
		return !isEqual(nextProps.match, match) || title !== nextProps.title;
	}

	renderSelect = () => {
		const {
			pathName,
			title,
			queryParams,
			targetSettings,
			target,
		} = this.props;

		return (
			<Section>
				<div className="d-flex flex-column h-100">
					<Section.Heading>{title}</Section.Heading>
					<div
						className={classnames(
							'd-flex flex-grow-1 flex-column align-items-center justify-content-center',
							styles.root
						)}
					>
						{
							[
								{ title: 'Presenter', items: presenterItems },
								{ title: 'Visualisation', items: visualizationItems },
							].map((group, index) => {
								const items = group.items
									.filter((item) => {
										const { feature } = item;
										return !feature || targetSettings[feature] === 'ALL';
									})
									.filter((item) => {
										const { excludedTargets } = item;
										return !excludedTargets || excludedTargets.indexOf(target.alias) === -1;
									});

								if (items.length === 0) {
									return null;
								}

								return (
									<div key={group.title} className={classnames('d-flex flex-column mb-5')}>
										<Section.SubHeading>{group.title}</Section.SubHeading>
										<div className={classnames(styles.list, 'd-flex')}>
											{items.map(item => (
												<div key={`link-${item.path}`} className={styles.card}>
													<Link
														id="quiz-navigation-btn"
														to={{
															pathname: `${pathName}/${item.path}`,
															search: toQueryString(queryParams),
														}}
													>
														<span>{item.title}</span>
													</Link>
												</div>
											))}
										</div>
									</div>
								);
							})
						}
					</div>
				</div>
			</Section>
		);
	};

	render() {
		const { match } = this.props;
		const type = toLower(get(match, 'params.type'));
		switch (type) {
			case 'quiz':
				return <Quiz />;
			case 'poll':
				return <Poll />;
			case 'pollvisualization':
				return <PollVisualization />;
			case 'quizvisualization':
				return <QuizVisualization />;
			case 'shoutboxvisualization':
				return <ShoutboxVisualization />;
			case 'challengevisualization':
				return <UgcVisualization />;
			default:
				return this.renderSelect();
		}
	}
}

Interaction.propTypes = {
	setChannel: PropTypes.func.isRequired,
	clearAndGetStream: PropTypes.func.isRequired,
	clearAndGetChannel: PropTypes.func.isRequired,
	pathName: PropTypes.string.isRequired,
	// eslint-disable-next-line react/forbid-prop-types
	targetSettings: PropTypes.object.isRequired,
	// eslint-disable-next-line react/forbid-prop-types
	target: PropTypes.object.isRequired,
	title: PropTypes.string,
};

Interaction.defaultProps = {};

export default Interaction;



// WEBPACK FOOTER //
// ./src/ui/interaction/Interaction.component.js